import React, { useState, useEffect } from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import CreatableSelect from "react-select/creatable";
import axios from "axios";
import "../styles/GlobalStyles.css";


/* ================= OPTIONS ================= */
const jobCategoryOptions = [
  { value: "Teaching", label: "Teaching" },
  { value: "Non-Teaching", label: "Non-Teaching" },
];

const workPlaceOptions = [
  { value: "School", label: "School" },
  { value: "Pre-School", label: "Pre-School" },
  { value: "College", label: "College" },
  { value: "University", label: "University" },
  { value: "EdTech", label: "EdTech" },
];

const roleTeachingOptions = [
  { value: "Teacher", label: "Teacher" },
  { value: "Assistant Teacher", label: "Assistant Teacher" },
  { value: "Head Teacher", label: "Head Teacher" },
  { value: "Special Educator", label: "Special Educator" },
];

const roleNonTeachingOptions = [
  { value: "Academic Counsellor", label: "Academic Counsellor" },
  { value: "Academic Coordinator", label: "Academic Coordinator" },
  { value: "Centre Head/Coordinator", label: "Centre Head/Coordinator" },
  { value: "Telecaller", label: "Telecaller" },
  { value: "Female Attendant", label: "Female Attendant" },
  { value: "Accounts Executive", label: "Accounts Executive" },
  { value: "School Admin/Office Manager", label: "School Admin/Office Manager" },
  { value: "Librarian", label: "Librarian" },
  { value: "Lab Assistant", label: "Lab Assistant" },
];

const boardOptions = [
  { value: "CBSE", label: "CBSE" },
  { value: "ICSE", label: "ICSE" },
];

const levelOptions = [
  { value: "Pre-Primary", label: "Pre-Primary" },
  { value: "Primary", label: "Primary" },
];

const subjectOptions = [
  { value: "Mathematics", label: "Mathematics" },
  { value: "Science", label: "Science" },
  { value: "English", label: "English" },
  { value: "Social Studies", label: "Social Studies" },
];

const experienceOptions = [
  { value: 0, label: "Fresher" },
  { value: 1, label: "1 Year" },
  { value: 2, label: "2 Years" },
  { value: 3, label: "3 Years" },
  { value: 4, label: "4 Years" },
  { value: 5, label: "5 Years" },
  { value: 6, label: "6 Years" },
  { value: 7, label: "7 Years" },
  { value: 8, label: "8 Years" },
  { value: 9, label: "9 Years" },
  { value: 10, label: "10 Years" },
  { value: 11, label: "11 Years" },
  { value: 12, label: "12 Years" },
  { value: 13, label: "13 Years" },
  { value: 14, label: "14 Years" },
  { value: 15, label: "15 Years" },
  { value: 16, label: "16 Years" },
  { value: 17, label: "17 Years" },
  { value: 18, label: "18 Years" },
  { value: 19, label: "19 Years" },
  { value: 20, label: "20 Years" },
  { value: 21, label: "21 Years" },
  { value: 22, label: "22 Years" },
  { value: 23, label: "23 Years" },
  { value: 24, label: "24 Years" },
  { value: 25, label: "25 Years" },
  { value: 26, label: "26 Years" },
  { value: 27, label: "27 Years" },
  { value: 28, label: "28 Years" },
  { value: 29, label: "29 Years" },
  { value: 30, label: "30 Years" },
];

const employmentTypeOptions = [
  { value: "Full Time", label: "Full Time" },
  { value: "Part Time", label: "Part Time" },
];

const cityOptions = [
  { value: 'Bagalkot', label: 'Bagalkot' },
  { value: 'Ballari (Bellary)', label: 'Ballari (Bellary)' },
  { value: 'Belagavi (Belgaum)', label: 'Belagavi (Belgaum)' },
  { value: 'Bengaluru', label: 'Bengaluru' },
  { value: 'Bidar', label: 'Bidar' },
  { value: 'Chamarajanagar', label: 'Chamarajanagar' },
  { value: 'Chikballapur', label: 'Chikballapur' },
  { value: 'Chikkamagaluru (Chikmagalur)', label: 'Chikkamagaluru (Chikmagalur)' },
  { value: 'Chitradurga', label: 'Chitradurga' },
  { value: 'Dakshina Kannada', label: 'Dakshina Kannada' },
  { value: 'Davangere', label: 'Davangere' },
  { value: 'Dharwad', label: 'Dharwad' },
  { value: 'Gadag', label: 'Gadag' },
  { value: 'Hassan', label: 'Hassan' },
  { value: 'Haveri', label: 'Haveri' },
  { value: 'Kalaburagi (Gulbarga)', label: 'Kalaburagi (Gulbarga)' },
  { value: 'Kodagu (Coorg)', label: 'Kodagu (Coorg)' },
  { value: 'Kolar', label: 'Kolar' },
  { value: 'Koppal', label: 'Koppal' },
  { value: 'Mandya', label: 'Mandya' },
  { value: 'Mysuru (Mysore)', label: 'Mysuru (Mysore)' },
  { value: 'Raichur', label: 'Raichur' },
  { value: 'Ramanagara', label: 'Ramanagara' },
  { value: 'Shivamogga (Shimoga)', label: 'Shivamogga (Shimoga)' },
  { value: 'Tumakuru (Tumkur)', label: 'Tumakuru (Tumkur)' },
  { value: 'Udupi', label: 'Udupi' },
  { value: 'Uttara Kannada (Karwar)', label: 'Uttara Kannada (Karwar)' },
  { value: 'Vijayapura (Bijapur)', label: 'Vijayapura (Bijapur)' },
  { value: 'Yadgir', label: 'Yadgir' },
  { value: 'Vijayanagara', label: 'Vijayanagara' }
];

const distanceOptions = [
  { value: 5, label: "5 km" },
  { value: 10, label: "10 km" },
  { value: 15, label: "15 km" },
  { value: 20, label: "20 km" },
];
const noticePeriodOptions = [
  { value: 15, label: "15 Days" },
  { value: 30, label: "30 Days" },
  { value: 45, label: "45 Days" },
  { value: 60, label: "60 Days" },
  { value: 75, label: "75 Days" },
  { value: 90, label: "90 Days" },
];

const WorkPreferences = ({ mode = "add", initialData, onSuccess }) => {
  const [step, setStep] = useState(1);

  const [jobCategory, setJobCategory] = useState(null);
  const [workPlace, setWorkPlace] = useState(null);
  const [board, setBoard] = useState(null);
  const [level, setLevel] = useState(null);
  const [subject, setSubject] = useState([]);
  const [role, setRole] = useState(null);

  const [experience, setExperience] = useState(null);

  const [noticePeriod, setNoticePeriod] = useState(null);
  const [employmentType, setEmploymentType] = useState(null);
  const [distance, setDistance] = useState(null);
  const [city, setCity] = useState(null);
  const [preferredLocation, setPreferredLocation] = useState(null);

  const isTeaching = jobCategory?.value === "Teaching";
  const isSchool = workPlace?.value === "School";
  const isPreSchool = workPlace?.value === "Pre-School";

  // Determine correct role options based on category
  const currentRoleOptions = isTeaching ? roleTeachingOptions : roleNonTeachingOptions;

  /* ================= EDIT MODE PREFILL ================= */
  useEffect(() => {
    if (mode !== "edit" || !initialData) return;

    setJobCategory(jobCategoryOptions.find(o => o.value === initialData.category) || null);
    setWorkPlace(workPlaceOptions.find(o => o.value === initialData.domain) || null);

    // Logic to find the correct role option from either list OR create a new one
    const savedRole = initialData.role_teaching || initialData.role_non_teaching || initialData.role;
    if (savedRole) {
      const allRoles = [...roleTeachingOptions, ...roleNonTeachingOptions];
      const found = allRoles.find(o => o.value === savedRole);
      setRole(found || { value: savedRole, label: savedRole });
    } else {
      setRole(null);
    }

    setBoard(boardOptions.find(o => o.value === initialData.preferred_board) || null);
    setLevel(levelOptions.find(o => o.value === initialData.preferred_level) || null);

    setSubject(
      Array.isArray(initialData.subject)
        ? initialData.subject.map(s => ({ value: s, label: s }))
        : []
    );

    setExperience(
      experienceOptions.find(o => o.value === initialData.experience) || null
    );



    setNoticePeriod(
      noticePeriodOptions.find(o => o.value === initialData.notice_period) || null
    );

    setEmploymentType(
      employmentTypeOptions.find(o => o.value === initialData.employment_type) || null
    );

    setCity(
      cityOptions.find(o => o.value === initialData.city) || null
    );

    setPreferredLocation(
      initialData.preferred_location
        ? { value: initialData.preferred_location, label: initialData.preferred_location }
        : null
    );

    setDistance(
      distanceOptions.find(o => o.value === Number(initialData.distance)) || null
    );

    setStep(1); // ✅ MUST OPEN STEP 1 FIRST
  }, [mode, initialData]);

  /* ================= ADD MODE LOAD ================= */


  /* ================= LOCATION SEARCH ================= */
  const loadLocationOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 2) return [];
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/locations/search?query=${inputValue}`
      );
      // Backend returns objects { area: "...", pincode: "..." }
      // We map this to value/label as STRINGS (area name only)
      return (res.data.locations || []).map((loc) => ({
        value: loc.area,
        label: loc.area,
      }));
    } catch (error) {
      console.error("Error fetching locations:", error);
      return [];
    }
  };

  const canGoNext = () => {
    if (!jobCategory || !workPlace) return false;
    if (isTeaching && isSchool) return board && level && subject.length > 0;
    // For Teaching+PreSchool OR NonTeaching, we need strict role selection
    return !!role;
  };

  const canSave =
    experience !== null &&

    noticePeriod !== null &&
    employmentType !== null &&
    city !== null &&
    preferredLocation !== null &&
    distance !== null;

  /* ================= SAVE ================= */
  const handleSave = async () => {
    if (!canSave) return alert("Please complete all mandatory fields");

    const token = localStorage.getItem("token");
    if (!token) return;

    const payload = {
      work_preference: {
        ...(initialData?._id ? { _id: initialData._id } : {}), // Include ID if editing
        category: jobCategory.value,
        domain: workPlace.value,

        // Split Role Logic
        role_teaching: isTeaching ? (isSchool && !role ? "Teacher" : role?.value) : undefined,
        role_non_teaching: !isTeaching ? role?.value : undefined,

        preferred_board: board?.value,
        preferred_level: level?.value,
        subject: subject.map(s => s.value),
        experience: experience.value,

        notice_period: noticePeriod.value,
        employment_type: employmentType.value,
        city: city.value,
        preferred_location: preferredLocation.label,
        distance: distance.value,
      },
    };

    await axios.put(
      `${process.env.REACT_APP_API_URL}/api/profile/update/work-preference`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    alert("Preferences saved successfully");
    onSuccess && onSuccess();
  };

  /* ================= UI ================= */

  if (step === 1) {
    return (
      <div className="profile-card page-container">
        <h2 className="page-title">Job Preference</h2>

        <label className="profile-label">Job Category *</label>
        <Select options={jobCategoryOptions} value={jobCategory} onChange={setJobCategory} />

        <label className="profile-label">Looking to work in *</label>
        <Select options={workPlaceOptions} value={workPlace} onChange={setWorkPlace} />

        {isTeaching && isSchool && (
          <>
            <label className="profile-label">Preferred Board *</label>
            <Select options={boardOptions} value={board} onChange={setBoard} />

            <label className="profile-label">Preferred Level *</label>
            <Select options={levelOptions} value={level} onChange={setLevel} />

            <label className="profile-label">Subjects *</label>
            <Select
              options={subjectOptions}
              value={subject}
              onChange={setSubject}
              isMulti

            />
          </>
        )}

        {(!isTeaching || isPreSchool) && (
          <>
            <label className="profile-label">Role *</label>
            <CreatableSelect
              options={currentRoleOptions}
              value={role}
              onChange={(newValue) => setRole(newValue)}

              isClearable
              placeholder="Select or Type Role..."
            />
          </>
        )}

        <button className="save-button" disabled={!canGoNext()} onClick={() => setStep(2)}>
          Next
        </button>
      </div>
    );
  }

  return (
    <div className="page-container profile-card">
      <h2 className="page-title">Work Preferences</h2>

      <label className="profile-label">Experience *</label>
      <Select options={experienceOptions} value={experience} onChange={setExperience} />



      <label className="profile-label">Notice Period *</label>
      <Select options={noticePeriodOptions} value={noticePeriod} onChange={setNoticePeriod} />

      <label className="profile-label">Employment Type *</label>
      <Select options={employmentTypeOptions} value={employmentType} onChange={setEmploymentType} />

      <label className="profile-label">City *</label>
      <Select
        options={cityOptions}
        value={city}
        onChange={(val) => {
          setCity(val);
          // Clear preferred location if switching to non-Bengaluru
          if (val && val.value !== 'Bengaluru') {
            setPreferredLocation(null);
          }
        }}
      />

      <label className="profile-label">
        Preferred Location {(!city?.value === 'Bengaluru' && city?.value) && <span style={{ fontSize: '0.8rem', color: '#9ca3af', fontWeight: 'normal' }}> (Not required)</span>} *
      </label>
      <AsyncSelect
        isDisabled={city?.value !== 'Bengaluru'}
        cacheOptions
        loadOptions={loadLocationOptions}
        defaultOptions
        value={preferredLocation}
        onChange={setPreferredLocation}
        placeholder={city?.value !== 'Bengaluru' ? "Select Bengaluru to enable search" : "Type to search location..."}
        isClearable
        styles={{
          control: (base, state) => ({
            ...base,
            backgroundColor: state.isDisabled ? '#f3f4f6' : 'white',
            opacity: state.isDisabled ? 0.7 : 1
          })
        }}
      />

      <label className="profile-label">Distance *</label>
      <Select options={distanceOptions} value={distance} onChange={setDistance} />

      <div className="button-row">
        <button className="save-button" onClick={() => setStep(1)}>Edit</button>
        <button className="save-button" disabled={!canSave} onClick={handleSave}>
          Save Preferences
        </button>
      </div>
    </div>
  );
};

export default WorkPreferences;
